
export default {
  /**
     * @description api请求基础路径
     */
  baseUrl: {
    //pro: 'http://192.168.1.124:8055/adminApi',
    pro: window.GlobalVariable.BaseUrl,
    // pro: 'http://localhost:7745/',
    // RequestParaSecrectKey: "1556896841231548",
    // RequestParaSecrectIV: "2099475638181938",
    // OpenRequestParaSecrect: true
    twoTitle: "Exam",
    //system: GlobalVariable.system,
    // wrong: GlobalVariable.wrong,
    OpenAppID: window.GlobalVariable.OpenAppID,
    OpenRedirectUrl: window.GlobalVariable.OpenRedirectUrl,
    OpenUrl: window.GlobalVariable.OpenUrl,
    // isVideo: window.GlobalVariable.isVideo
    isVideo: true,
    isUserAgent: navigator.userAgent.toLowerCase().indexOf(' electron/')
    // isUserAgent: true
  },
  /**
     * @description 默认打开的首页的路由name值，默认为home
     */
  homeName: "home",
  // imgServer: "http://47.93.203.158:8070/img/newsimage/"
  // imgServer: "http://192.168.1.124:8099/img/newsimage/",
  imgServer: window.GlobalVariable.imgServer,
  StudentEnCode: "curriculum"
};



// WEBPACK FOOTER //
// ./src/config/index.js